export default __webpack_public_path__ + "static/media/Rectangle 151@2x.86eb44e6.png";